export default __webpack_public_path__ + "static/media/category_2.5a85cf3f.png";